<template>
  <div style="height: 100vh">
    <!-- <select-with-search style="width: 400px" :value="selectedRow" :table-data="tableData" @selectionChanged="onSelectRow">
      <template v-if="selectedRow.name" v-slot:value>
        {{ selectedRow.name }}
      </template>

      <template v-slot:table="{ tableRows, onSelectItem }">
        <table class="scroll-body">
          <thead>
            <tr>
              <th>Tên</th>
              <th>Mô tả</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="data in tableRows"
              :key="data.id"
              style="cursor: pointer"
              :class="{
                'row-focus': selectedRow.id == data.id
              }"
              @click="onSelectItem(data)"
            >
              <td>{{ data.id }} - {{ data.name }}</td>
              <td>{{ data.description }}</td>
            </tr>
          </tbody>
        </table>
      </template>
    </select-with-search> -->

    <select-with-search-table
      label="Search with all cols"
      style="width: 600px"
      :rows="[]"
      :columns="columns"
      index-field="code"
      :selected-index-field-value="selectedRow.code"
      :value="selectedRow.code"
      @selectionChanged="onSelectRow"
    >
      <template v-slot:value="{ selectedValue: selectedData }">
        {{ selectedData?.name }} {{ selectedData?.code }}
      </template>
    </select-with-search-table>

    <select-with-search-table
      label="Search by name only"
      style="width: 600px"
      :rows="rows"
      :columns="columns"
      :search-fields="['name']"
      index-field="code"
      :selected-index-field-value="selectedRow.code"
      :is-remove-btn="true"
      @selectionChanged="onSelectRow"
    >
      <template v-slot:value="{ selectedValue: selectedData }">
        {{ selectedData?.name }} {{ selectedData?.code }}
      </template>
    </select-with-search-table>

    <!-- <select-with-search-table
      label="Search By Name Only"
      :selected-row="selectedRow"
      :search-fields="['name']"
      style="width: 600px"
      :rows="rows"
      :columns="columns"
    />

    <select-with-search-table
      label="Search By Name with Code"
      :selected-row="selectedRow"
      :search-fields="['nameWithCode']"
      style="width: 400px"
      :rows="rowsAddNameWithCode"
      :columns="columns"
    /> -->

    <select-with-search-table
      label="Search with all cols, select multiple"
      style="width: 600px"
      :rows="rows"
      :columns="columns2"
      index-field="code"
      :selected-index-field-value="selectedRows"
      :is-remove-btn="true"
      multiple
      @selectionChanged="onSelectMultipleRow"
    >
      <template v-slot:value="{ selectedValue: selectedData }">
        <span v-for="data in selectedData" :key="data.code"
          >{{ data.name }},
        </span>
        <!-- {{ selectedData?.name }} {{ selectedData?.code }} -->
      </template>
    </select-with-search-table>
  </div>
</template>

<script>
import SelectWithSearch from './SelectWithSearchTableOld.vue'
// import SelectWithSearchTable from './SelectWithSearchTable.vue'
import SelectWithSearchTable from './SelectWithSearchTable.vue'

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    SelectWithSearch,
    // SelectWithSearchTable,
    // eslint-disable-next-line vue/no-unused-components
    SelectWithSearchTable
  },
  data() {
    return {
      selectedRow: {
        code: '15122001'
      },
      selectedRows: ['15122001', '20194224'],
      columns: [
        {
          headerName: 'Tên',
          field: 'name',
          cellClass: 'grid-cell-centered',
          minWidth: 200,
          flex: 1,
          valueGetter: params => {
            // console.log(params)
            return params.data.name + ' - ' + params.data.code
          }
        },
        {
          headerName: 'Đại học',
          field: 'university',
          cellClass: 'grid-cell-centered',
          minWidth: 200,
          flex: 1
        },
        {
          headerName: 'Tuổi',
          field: 'age',
          cellClass: 'grid-cell-centered',
          minWidth: 100,
          flex: 1
        }
      ],
      columns2: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: 'Tên',
          field: 'name',
          cellClass: 'grid-cell-centered',
          // minWidth: 200,
          flex: 1,
          valueGetter: params => {
            return params.data.name + ' - ' + params.data.code
          }
        },
        {
          headerName: 'Đại học',
          field: 'university',
          cellClass: 'grid-cell-centered',
          // minWidth: 200,
          flex: 1
        },
        {
          headerName: 'Tuổi',
          field: 'age',
          cellClass: 'grid-cell-centered',
          // minWidth: 300,
          flex: 1
        }
      ],
      rows: [
        {
          name: 'Nguyễn Văn A',
          code: '20194224',
          university: 'Đại học Bách Khoa',
          age: 18
        },
        {
          name: 'Lê Thị B',
          code: '20231010',
          university: 'Đại học Kinh tế Quốc Dân',
          age: 20
        },
        {
          name: 'Đỗ Văn C',
          code: '15122001',
          university: 'Đại học Ngoại Thương',
          age: 24
        },
        {
          name: 'Nông Mạnh D',
          code: '34561234',
          university: 'Đại học Xây dựng',
          age: 32
        }
      ],
      tableData: [
        { id: 1, name: 'test01', description: 'Loại giao dịch' },
        { id: 2, name: 'test02', description: 'Đồ ăn uống' },
        { id: 3, name: 'test03', description: 'Bách Khoa' },
        { id: 4, name: 'test04', description: 'Xây dựng' },
        { id: 5, name: 'test05', description: 'Kinh tế' },
        { id: 6, name: 'test06', description: 'Ngoại thương' }
      ]
    }
  },
  computed: {
    rowsAddNameWithCode() {
      return this.rows.map(row => ({
        ...row,
        nameWithCode: row.name + ' - ' + row.code
      }))
    }
  },
  methods: {
    onClickItem(id) {},
    onSelectRow(val) {
      this.selectedRow = { ...val }
    },
    onSelectMultipleRow(val) {
      // this.selectedRow = { ...val }
      this.selectedRows = val?.map(item => item.code) ?? null
    }
  }
}
</script>

<style lang="scss" scoped>
// table {
//   thead {
//     table-layout: fixed !important;
//     width: 100%;
//     display: table;
//   }

//   tbody {
//     display: block;
//     overflow-y: scroll;
//     max-height: 100px;
//     tr {
//       table-layout: fixed !important;
//       width: 100%;
//       display: table;
//       cursor: pointer;
//       &:hover {
//         background-color: wheat;
//       }
//     }
//   }
// }
</style>
